import { render, staticRenderFns } from "./projectCard.vue?vue&type=template&id=b55a1368&scoped=true"
import script from "./projectCard.vue?vue&type=script&lang=js"
export * from "./projectCard.vue?vue&type=script&lang=js"
import style0 from "./projectCard.vue?vue&type=style&index=0&id=b55a1368&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55a1368",
  null
  
)

export default component.exports